/* eslint-disable */
/// This file is auto generated - do not edit manually
export const HeaderLabel = 'Website.ArticleUniverse.SectionNavigationMenu.HeaderLabel';
export const ButtonLabel = 'Website.ArticleUniverse.SectionNavigationMenu.ButtonLabel';
export const FrontPage = 'Website.ArticleUniverse.SectionNavigationMenu.FrontPage';
